import cn from 'classnames';
import {useNavigate} from 'react-router-dom';

import {SpanIcon} from '@mazraeapp/react_icon_kit';
import Modal from '../../../../../components/mazraeKit/modal';

interface IAcceptedRegesterationModalProps {
  advertisementResultModal: boolean;
  setAdvertisementResultModal: React.Dispatch<React.SetStateAction<boolean>>;
  rejectedAd?: number;
  totalModal: number;
  stateValue: IAddedAdvertisementResponse;
  notifcaitons?: INotificationAdvertisement;
}

const AdvertisementResultModal = ({
  advertisementResultModal,
  setAdvertisementResultModal,
  rejectedAd,
  totalModal,
  stateValue,
  notifcaitons,
}: IAcceptedRegesterationModalProps) => {
  const navigate = useNavigate();

  const firstAdModal =
    notifcaitons?.advertisement?.[0] ?? notifcaitons?.requirement?.[0] ?? null;
  const adType = notifcaitons?.advertisement?.[0]
    ? notifcaitons?.advertisement[0]?.advertisement?.ad_type
    : 'personal';

  const handleModalHeader = () => {
    switch (true) {
      case rejectedAd === 0 && totalModal === 1:
        return 'انتشار آگهی در انتظار';
      case rejectedAd === 0 && totalModal > 1:
        return 'انتشار آگهی‌های در انتظار';
      case rejectedAd === 1:
        return 'عدم تأیید آگهی در انتظار';
      case rejectedAd && rejectedAd > 1:
        return `عدم تأیید آگهی‌های در انتظار`;
    }
  };

  const handleModalDesc = () => {
    switch (true) {
      case rejectedAd === 0 &&
        totalModal === 1 &&
        firstAdModal?.type === 'pending':
        return 'آگهی شما در انتظار بررسی کارشناسان مزرعه است و پس از بررسی منتشر خواهد شد.';
      case rejectedAd === 0 && totalModal === 1:
        return 'آگهی شما مورد تأیید قرار گرفت و منتشر شد.';
      case rejectedAd === 0 && totalModal > 1:
        return 'آگهی‌های شما مورد تأیید قرار گرفتند و منتشر شدند.';
      case rejectedAd === 1:
        return 'آگهی در انتظار، مورد تأیید قرار نگرفت. برای رفع نواقص وارد صفحه مدیریت آگهی شوید.';
      case rejectedAd && rejectedAd > 1:
        return `${rejectedAd} آگهی در انتظار، مورد تأیید قرار نگرفتند. برای رفع نواقص وارد صفحه مدیریت آگهی شوید.`;
    }
  };

  return (
    <Modal
      isOpen={advertisementResultModal}
      setIsOpen={setAdvertisementResultModal}
    >
      <div className="w-[320px] flex flex-col p-3 gap-3 justify-center items-center">
        <div className="flex justify-between items-center">
          <div className="flex w-[90%] justify-center">
            <SpanIcon
              className={cn(
                'icon-nameCheck-circle text-xxl  text-farm-shop-500',
                {
                  'icon-styleoutline86 text-red-600':
                    rejectedAd && rejectedAd > 0,
                  'icon-nameCheck-circle text-farm-shop-500': rejectedAd === 0,
                },
              )}
            />
          </div>
          <button
            aria-label="بستن"
            onClick={() => setAdvertisementResultModal(false)}
            className="absolute top-3 left-3"
          >
            <SpanIcon className="text-2xl text-gray-700 icon-nameClose-remove" />
          </button>
        </div>
        <h5 className="flex justify-center w-full text-gray-950">
          {handleModalHeader()}
        </h5>
        <p className="p-0 m-0 w-full text-gray-700 text-md font-Regular">
          {stateValue
            ? stateValue?.data?.submit_status === 'published'
              ? 'آگهی شما با موفقیت در فروشگاه مزرعه منتشر شد.'
              : 'آگهی شما توسط کارشناسان مزرعه بررسی و سپس منتشر خواهد شد.'
            : handleModalDesc()}
        </p>
        {rejectedAd === 0 ? (
          <button
            className="mt-1 w-full h-10 text-sm text-white rounded bg-farm-shop-500 text-regular"
            onClick={() => {
              adType === 'store'
                ? navigate('/my-store-advertisement')
                : navigate('/my-ads');
            }}
          >
            ورود به مدیریت اگهی
          </button>
        ) : (
          <div className="flex gap-2">
            <button
              className="text-red-600 border-[1px] border-red-600 bg-white rounded h-10 w-full mt-1 text-regular text-sm"
              onClick={() => {
                setAdvertisementResultModal(false);
              }}
            >
              انصراف
            </button>
            <button
              className="mt-1 w-full h-10 text-sm text-white rounded bg-farm-shop-500 text-regular"
              onClick={() => {
                adType === 'store'
                  ? navigate('/my-store-advertisement')
                  : navigate('/my-ads');
              }}
            >
              مدیریت اگهی
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default AdvertisementResultModal;
